import { render } from "./ProductReviewsComponent.vue?vue&type=template&id=23584d16"
import script from "./ProductReviewsComponent.vue?vue&type=script&lang=js"
export * from "./ProductReviewsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__